import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'utils/i18n';
import StylingMockLayout from '../shared/StylingMockLayout';
import './StylingMockIndex.css';

/**
 * Styling Mock Index Page
 * Overview page with category cards linking to component showcase pages
 */
const StylingMockIndex = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const categories = [
    {
      path: '/styling-mock/buttons',
      title: t('header.navigationGroups.pressKit.items.buttons'),
      description: 'Explore all button components including primary, secondary, outline, danger, success, loading, and icon-only buttons.'
    },
    {
      path: '/styling-mock/containers',
      title: t('header.navigationGroups.pressKit.items.containers'),
      description: 'View container components like HeroSection, CTASection, FeatureGrid, ContentPanel, and InteractiveNavigation.'
    },
    {
      path: '/styling-mock/ui',
      title: t('header.navigationGroups.pressKit.items.ui'),
      description: 'Browse UI elements including MarketCard, InfoBlock, ProductToggle, SlideOver, and other interactive components.'
    },
    {
      path: '/styling-mock/typography',
      title: t('header.navigationGroups.pressKit.items.typography'),
      description: 'See typography styles for headings (h1-h6), paragraphs, links, lists, blockquotes, code blocks, and text formatting.'
    },
    {
      path: '/styling-mock/logo',
      title: t('header.navigationGroups.pressKit.items.logo'),
      description: 'Discover logo variations, sizes, light/dark mode versions, and usage examples in different containers.'
    },
    {
      path: '/styling-mock/layouts',
      title: t('header.navigationGroups.pressKit.items.layouts'),
      description: 'Explore page layout structures including static pages, content pages, dashboards, and form layouts.'
    },
    {
      path: '/styling-mock/animations',
      title: t('header.navigationGroups.pressKit.items.animations'),
      description: 'View animation components like FloatingElements and ProgressIndicator with interactive examples.'
    }
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <StylingMockLayout>
      <div className="styling-mock-index">
        <div className="styling-mock-index-header">
          <h1 className="styling-mock-index-title">Component Showcase</h1>
          <p className="styling-mock-index-description">
            Browse our comprehensive library of UI components, containers, typography, and layouts. 
            Each section provides live examples, code snippets, and usage guidelines.
          </p>
        </div>

        <div className="styling-mock-index-grid">
          {categories.map((category) => (
            <div
              key={category.path}
              className="styling-mock-index-card"
              onClick={() => handleCardClick(category.path)}
            >
              <h3 className="styling-mock-index-card-title">{category.title}</h3>
              <p className="styling-mock-index-card-description">{category.description}</p>
              <div className="styling-mock-index-card-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </StylingMockLayout>
  );
};

export default StylingMockIndex;

